import { Link } from 'react-router-dom';

export function NotFound() {
    return (
        <section>
            <div className="mx-auto max-w-4xl px-6 py-32 text-center">
                <div className="text-6xl font-bold text-ptm-accent">404</div>
                <h1 className="mt-4 text-3xl font-bold tracking-tight">Page not found</h1>
                <p className="mt-4 text-slate-600">The page you were looking for doesn&rsquo;t exist.</p>
                <Link
                    to="/"
                    className="mt-8 inline-block rounded-md bg-ptm-accent px-6 py-3 font-semibold text-white no-underline hover:bg-orange-600"
                >
                    Back to home
                </Link>
            </div>
        </section>
    );
}
